<template>
  <el-container v-loading="isShow" element-loading-text="拼命加载中">
    <div class="comp">
      <div class="panel1">
        <div class="tit">门店业绩目标</div>
        <div class="tableBox">
          <div class="tit1">
            <div class="cell1">项目</div>
            <div
              class="cell1"
              v-for="(item, index) in datas.shop_data_list"
              :key="index"
            >
              {{ item.shop_info.shop_name }}
            </div>
          </div>
          <div class="row1">
            <div class="cell1">月目标</div>
            <div
              class="cell1"
              v-for="(item, index) in datas.shop_data_list"
              :key="index"
            >
              {{ item.month_target.toFixed(2) }}
            </div>
          </div>
          <div class="row1">
            <div class="cell1">门店流水</div>
            <div
              class="cell1"
              v-for="(item, index) in datas.shop_data_list"
              :key="index"
            >
              {{ item.month_performance.toFixed(2) }}
            </div>
          </div>
          <div class="row1">
            <div class="cell1">差距</div>
            <div
              class="cell1"
              v-for="(item, index) in datas.shop_data_list"
              :key="index"
            >
              <span v-if="item.target_difference < 0"
                >超出 {{ Math.abs(item.target_difference).toFixed(2) }}</span
              >
              <span v-else>{{ item.target_difference.toFixed(2) }}</span>
            </div>
          </div>
          <div class="row1">
            <div class="cell1">完成度</div>
            <div
              class="cell1"
              v-for="(item, index) in datas.shop_data_list"
              :key="index"
            >
              {{
                (
                  (item.month_performance / item.month_target) *
                  10000
                ).toFixed() /
                  100 +
                "%"
              }}
            </div>
          </div>
          <div class="row1">
            <div class="cell1">门店退款</div>
            <div
              class="cell1"
              v-for="(item, index) in datas.shop_data_list"
              :key="index"
            >
              {{ item.refund_money.refund_money.toFixed(2) }}
              <el-tooltip effect="dark" placement="top-start">
                <div slot="content" style="line-height: 20px">
                  当月现金：{{ item.refund_money.currentMonthReturnCash }}<br />
                  当月余额：{{ item.refund_money.currentMonthReturnYue }}<br />
                  当月充值：{{ item.refund_money.currentMonthReturnRecharge
                  }}<br />
                  往月现金：{{ item.refund_money.lastMonthReturnCash }}<br />
                  往月余额：{{ item.refund_money.lastMonthReturnYue }}<br />
                  往月充值：{{ item.refund_money.lastMonthReturnRecharge
                  }}<br />
                </div>
                <img
                  src="../../../assets/img/icon_eye.jpg"
                  style="width: 20px; margin-left: 0px; vertical-align: middle"
                />
              </el-tooltip>
            </div>
          </div>
          <div class="row1">
            <div class="cell1">活体目标</div>
            <div
              class="cell1"
              v-for="(item, index) in datas.shop_data_list"
              :key="index"
            >
              {{ item.living_target }}
            </div>
          </div>

          <div class="row1">
            <div class="cell1">完成活体数</div>
            <div
              class="cell1"
              v-for="(item, index) in datas.shop_data_list"
              :key="index"
            >
              {{ item.living_performance }}
            </div>
          </div>
          <div class="row1">
            <div class="cell1">活体差距数</div>
            <div
              class="cell1"
              v-for="(item, index) in datas.shop_data_list"
              :key="index"
            >
              <span v-if="item.living_target_difference < 0"
                >超出 {{ Math.abs(item.living_target_difference) }}</span
              >
              <span v-else>{{ item.living_target_difference }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="panel2">
        <div class="tit">业绩完成折线图</div>
        <div class="tableBox" id="myChart0" style="height: 420px"></div>
      </div>
      <div class="panel3">
        <div class="tit">门店完成度</div>
        <div class="tableBox" v-if="!$public.isNull(datas.shop_week_data_list)">
          <div class="tit1">
            <div class="cell1"></div>
            <div class="cell1">项目</div>
            <div
              class="cell1 row"
              v-for="(item, index) in datas.shop_week_data_list[0]
                .shop_Week_Data_Detail_list"
              :key="index"
            >
              {{ item.shop_info.shop_name }}
            </div>
          </div>
          <!-- <div class="row1">
					<div class="cell1"></div>
					<div class="cell1">周目标</div>
					<div class="cell1" v-for="(item,index) in datas.shop_week_data_list[0].shop_Week_Data_Detail_list" :key="index">{{item.week_target.toFixed(2)}}</div>
				</div> -->
          <div
            class="row1 row"
            v-for="(item, index) in datas.shop_week_data_list"
            :key="index"
          >
            <div
              class="cell1"
              style="
                display: flex;
                flex-direction: column;
                justify-content: center;
              "
            >
              第{{ $public.formatNumTochinese(index + 1) }}周
            </div>
            <div class="cell1">
              <div style="border-bottom: 1px solid #e6e6e6">周目标</div>
              <div style="border-bottom: 1px solid #e6e6e6">周业绩</div>
              <div style="border-bottom: 1px solid #e6e6e6">周退款</div>
              <div>周完成率</div>
            </div>
            <div
              class="cell1"
              v-for="(shop, shopIndex) in item.shop_Week_Data_Detail_list"
              :key="shopIndex"
            >
              <div style="border-bottom: 1px solid #e6e6e6">
                {{ shop.week_target.toFixed(2) }}
              </div>
              <!-- <div class="cell1" v-for="(item,index) in datas.shop_week_data_list[0].shop_Week_Data_Detail_list" :key="index">{{item.week_target.toFixed(2)}}</div> -->
              <div style="border-bottom: 1px solid #e6e6e6">
                {{ shop.week_performance.toFixed(2) }}
              </div>
              <div style="border-bottom: 1px solid #e6e6e6">
                {{ shop.week_refund.refund_money.toFixed(2) }}
                <el-tooltip effect="dark" placement="top-start">
                  <div slot="content" style="line-height: 20px">
                    当月现金：{{ shop.week_refund.currentMonthReturnCash
                    }}<br />
                    当月余额：{{ shop.week_refund.currentMonthReturnYue }}<br />
                    当月充值：{{ shop.week_refund.currentMonthReturnRecharge
                    }}<br />
                    往月现金：{{ shop.week_refund.lastMonthReturnCash }}<br />
                    往月余额：{{ shop.week_refund.lastMonthReturnYue }}<br />
                    往月充值：{{ shop.week_refund.lastMonthReturnRecharge
                    }}<br />
                  </div>
                  <img
                    src="../../../assets/img/icon_eye.jpg"
                    style="
                      width: 20px;
                      margin-left: 0px;
                      vertical-align: middle;
                    "
                  />
                </el-tooltip>
              </div>
              <div>
                {{ shop.week_rate === -1 ? "--" : shop.week_rate + "%" }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="panel4">
        <div class="tit">业绩完成率柱状图</div>
        <div class="tableBox" id="myChart1" style="height: 400px"></div>
      </div>
    </div>
  </el-container>
</template>
<script>
import echarts from "echarts";
export default {
  data() {
    return {
      isShow: false,
      datas: {
        shop_data_list: [],
        week_setting_list: [],
      },
      myChart0: null,
      myChart1: null,
    };
  },
  computed: {},
  props: {
    refresh: {
      default: 0,
    },
  },
  watch: {
    refresh() {
      this.getDatas();
    },
  },
  created() {
    this.getDatas();
  },
  mounted() {
    this.myChart0 = echarts.init(document.getElementById("myChart0"));
    this.myChart1 = echarts.init(document.getElementById("myChart1"));
  },
  methods: {
    getDatas() {
      // this.state1 = false;
      let params = {
        month_info: this.$public.FTime(
          sessionStorage.getItem("pkMonth"),
          "YYYY-MM"
        ), // 月份信息(2021-10)
      };
      this.isShow = true;
      // let loading = this.$loading();
      this.$http
        .get(
          process.env.VUE_APP_Url9 +
            "api/ShopPerformancePKService/ShopPerformancePKReturnView",
          params
        )
        .then((res) => {
          // loading.close();
          this.isShow = false;
          this.datas = res.data;
          console.log(res, "数据");
          this.$nextTick(() => {
            // this.state1 = true;
            this.draw0();
            this.draw1();
          });
        });
    },
    draw0() {
      let x = [];
      for (let i = 0; i < this.datas.week_setting_list.length; i++) {
        x.push(this.datas.week_setting_list[i].week_name);
      }
      let series = [];
      for (
        let i = 0;
        i < this.datas.shop_week_data_line_chart_list.length;
        i++
      ) {
        let item = this.datas.shop_week_data_line_chart_list[i];
        item.type = "line";
        item.data = item.week_performance_list;
        item.name = item.shop_info.shop_name;
        series.push(item);
      }
      this.myChart0.setOption({
        color: [
          "#F76260",
          "#96D9FF",
          "#FBCB63",
          "#8167F5",
          "#28D3DB",
          "#F5EC67",
          "#F5882A",
          "#58A2F7",
        ],
        legend: { left: "right" },
        tooltip: {
          trigger: "axis",
          // showContent: false
        },
        yAxis: {
          gridIndex: 0,
          type: "value",
          name: "业绩",
        },
        grid: { top: "15%" },
        xAxis: {
          type: "category",
          name: "周数",
          splitLine: { show: false },
          data: x,
        },
        series: series,
      });
    },
    draw1() {
      let series = [{ type: "bar", label: { show: true, position: "top" } }];
      let source = [];
      for (let i = 0; i < this.datas.shop_setting_list.length; i++) {
        series.push({ type: "bar", label: { show: true, position: "top" } });
        if (this.datas.shop_week_data_list[i]) {
          let shops =
            this.datas.shop_week_data_list[i].shop_Week_Data_Detail_list; //门店的周完成路
          let product = ["product"];
          let col = [
            this.datas.shop_week_data_list[i].week_setting_item.week_name,
          ];
          for (let a = 0; a < shops.length; a++) {
            product.push(shops[a].shop_info.shop_name);
            col.push(shops[a].week_rate);
          }
          if (i === 0) {
            source.push(product);
          }
          source.push(col);
        }
      }
      // console.log(series,source)
      this.myChart1.setOption({
        color: [
          "#3789FF",
          "#37C9FF",
          "#37EDFF",
          "#CEA6FF",
          "#8167F5",
          "#F5EC67",
          "#28D3DB",
          "#96D9FF",
        ],
        legend: { left: "right" },
        tooltip: {
          trigger: "item",
          axisPointer: {
            type: "shadow",
          },
          formatter: (val) => {
            let week_target = "";
            let week_performance = "";
            let week_rate = "";
            for (let i = 0; i < this.datas.shop_week_data_list.length; i++) {
              if (
                this.datas.shop_week_data_list[i].week_setting_item
                  .week_name === val.name
              ) {
                let shops =
                  this.datas.shop_week_data_list[i].shop_Week_Data_Detail_list;
                for (let a = 0; a < shops.length; a++) {
                  if (shops[a].shop_info.shop_name === val.seriesName) {
                    week_target = shops[a].week_target;
                    week_performance = shops[a].week_performance;
                    week_rate = shops[a].week_rate;
                  }
                }
              }
            }
            let str = val.name + "<br>";
            str += "周目标：" + week_target + "<br>";
            str += "周业绩：" + week_performance + "<br>";
            str += "周完成率：" + week_rate + "<br>";
            return str;
          },
        },
        yAxis: {
          type: "value",
          gridIndex: 0,
          name: "周完成率 (%)",
        },
        grid: { top: "15%" },
        xAxis: {
          type: "category",
          name: "周数",
          splitLine: { show: false },
        },
        series: series,
        dataset: {
          source: source,
        },
      });
    },
  },
};
</script>
<style scoped lang="scss">
.comp {
  width: 100%;
  background-color: #fff;
  display: flex;
  flex-wrap: wrap;
  height: 100vh;
  .panel1 {
    padding: 22px 20px;
    box-sizing: border-box;
    width: calc(100% - 600px);
    background-color: #fff;
    .tit {
      font-size: 18px;
      color: $fontColor;
      font-weight: bold;
      padding-bottom: 14px;
    }
    .tableBox {
      border-left: 1px solid #e6e6e6;
      .tit1 {
        display: flex;
        line-height: 52px;
        border-bottom: 1px solid #e6e6e6;
        .cell1 {
          background-color: #f3f5fa;
          width: 100%;
          text-align: center;
          border-right: 1px solid #e6e6e6;
        }
      }
      .row1 {
        display: flex;
        line-height: 52px;
        .cell1 {
          width: 100%;
          text-align: center;
          border-right: 1px solid #e6e6e6;
          border-bottom: 1px solid #e6e6e6;
        }
      }
    }
  }
  .panel2 {
    padding: 22px 20px;
    box-sizing: border-box;
    width: 600px;
    background-color: #fff;
    .tit {
      font-size: 18px;
      color: $fontColor;
      font-weight: bold;
      padding-bottom: 14px;
    }
  }
  .panel3 {
    padding: 22px 20px;
    box-sizing: border-box;
    width: calc(100% - 600px);
    border-top: 1px solid #f1f1f1;
    background-color: #fff;
    .tit {
      font-size: 18px;
      color: $fontColor;
      font-weight: bold;
      padding-bottom: 14px;
    }
    .tableBox {
      .tit1 {
        display: flex;
        line-height: 52px;
        border-bottom: 1px solid #e6e6e6;
        .cell1 {
          background-color: #f3f5fa;
          width: 100%;
          text-align: center;
          border-right: 1px solid #e6e6e6;
          &:first-child {
            width: 60px;
            flex-shrink: 0;
          }
          &:last-child {
          }
        }
      }
      .row1 {
        display: flex;
        line-height: 52px;
        .cell1 {
          width: 100%;
          text-align: center;
          border-right: 1px solid #e6e6e6;
          border-bottom: 1px solid #e6e6e6;
          &:first-child {
            width: 60px;
            flex-shrink: 0;
            background-color: #f3f5fa;
          }
          &:last-child {
          }
        }
      }
    }
  }
  .panel4 {
    padding: 22px 20px;
    box-sizing: border-box;
    width: 600px;
    border-top: 1px solid #f1f1f1;
    background-color: #fff;
    .tit {
      font-size: 18px;
      color: $fontColor;
      font-weight: bold;
      padding-bottom: 14px;
    }
  }
}
.row:nth-child(odd) {
  background: rgb(223, 218, 218);
}
</style>
